import React from 'react';
import { StyledPeopleGrid } from './StyledPeopleGrid';
import PeopleCell  from '../PeopleCell';

const PeopleGrid = () => {
  const arrayPeople = [
    {
      "image": require('../../assets/people/01-matteoesposito-hover.jpg'),
      "name": "Matteo Esposito",
      "position": "CEO & Co-founder"
    },
    {
      "image": require('../../assets/people/02-floracaroli-hover.jpg'),
      "name": "Flora Caroli",
      "position": "Co-founder"
    },
    {
      "image": require('../../assets/people/03-paolopascolo-hovercolor.jpg'),
      "name": "Paolo Pascolo",
      "position": "Co-founder"
    },
    {
      "image": require('../../assets/people/12-luca----hovercolor.jpg'),
      "name": "Luca Ferrari Trecate",
      "position": "Co-founder"
    },
    {
      "image": require('../../assets/people/04-paolobonetti-hovercolor.jpg'),
      "name": "Paolo Bonetti",
      "position": "CFO"
    },
    {
      "image": require('../../assets/people/07-fabriziodini-hovercolor.jpg'),
      "name": "Fabrizio Dini",
      "position": "COO - Head of 3d Content"
    },
    {
      "image": require('../../assets/people/09-ernestnemirovskiy-hovercolor.jpg'),
      "name": "Ernest Nemirovskiy",
      "position": "Lead 3d Artist"
    },
    {
      "image": require('../../assets/people/10-lucazini-hovercolor.jpg'),
      "name": "Luca Zini",
      "position": "CDO"
    },
    {
      "image": require('../../assets/people/15-marcozago-hovercolor.jpg'),
      "name": "Marco Zago",
      "position": "AFC - HR"
    } 
    
  ]
  return (
    <React.Fragment>
      {
        <StyledPeopleGrid>
          {
            arrayPeople.map((key, index) => {
              return <PeopleCell key={index}
                      image={key.image} 
                      name={key.name} 
                      position={key.position}
                    />
            })
            
          }
        </StyledPeopleGrid>
          
      }
    </React.Fragment>
  );
};

export default PeopleGrid;
